import Form from 'react-bootstrap/Form';

function FormControl(props) {
  return <Form.Control {...props} />
}

export default FormControl;
